const Form076SC = {
    stepName: {
        importantNotes: "重要事项",
        parentParticulars: "家长资料",
        childrenParticulars: "需要协助儿童的资料",
        confirmation: "确认",
    },
    title: {
        note: "注意",
        enquiries: "查询",
        contactDetailsOfREOs: "教育局各区域教育服务处的联络资料",
        contactDetailsOfChildren: "教育局学位安排及支援组的联络资料",
        basicEducationInformation: "香港特别行政区的教育服务(簡介)",
        basicEducationInformationUrl:
            "https://www.edb.gov.hk/attachment/en/student-parents/placement-assistance/about-placement-assistance/Business%20Reply%202020.12_SC.pdf",
        assistanceRequired: "所需協助：",
    },
    label: {
        name: "姓名",
        officeTelephone: "办事处电话",
        contactTelephone: "本地联络电话",
        address: "住址",
        sameAddress: "与通讯地址相同",
        correspondenceAddress: "通讯地址（如与上述住址不同）",
        email: "电邮",
        birthDate: "出生日期",
        gender: "性別",
        leavingGrade: "离校时年级",
        leavingDate: "离校日期",
        firstArrivalDate: "首次抵港日期",
        joiningProgramme: "参加适应课程",
        enrollingProgramme: "报读启动课程",
        enrollingMainstream: "入读本港主流学校",
        enrollingSpecial: "入读特殊学校，类别：",
        intellectualDisability: "智障儿童学校",
        hearingImpairment: "听障儿童学校",
        visualImpairment: "视障儿童学校",
        physicalDisability: "肢体伤残儿童学校",
        educationalAssistance: "其他教育方面的协助 ( 请说明 )",
        genderOptions: {
            male: "男",
            female: "女",
        },
    },
    errorMsg: {
        parentName: "家长姓名",
        contactTelephone: "本地联络电话",
        address: "住址",
        correspondenceAddress: "通讯地址（如与上述住址不同）",
        specify: "请说明其他教育方面的協助",
        validSpecify: "说明",
        childName: "儿童姓名",
        birthDate: "出生日期",
        gender: "性別",
        requiredAgreement: "请勾选方框以证明你理解并同意上述条款和条件。",
        leavingGrade: "离校时年级",
        leavingDate: "离校日期",
        firstArrivalDate: "首次抵港日期",
        email: "电邮",
    },
    note: {
        note1: "新来港人士如需查询上述教育服务，可使用教育局的 24 小时电话查询服务或浏览教育局网站 <a href='https://www.edb.gov.hk'>https://www.edb.gov.hk</a>。",
        note2: "教育局 24 小时电话查询服务：2891 0088",
        note3: "",
        note4: "新来港人士亦可亲自带同有关学童及所需文件之正副本，前往教育局各区域教育服务处登记学位安排支援服务。",
        note5: "区域教育服务处",
        note6: "地址",
        note7: "电话",
        note8: "传真",
        note9: "港岛区域教育服务处",
        note10: "香港太古城太古湾道 14 号 3 楼",
        note11: "2863 4646",
        note12: "2865 0658",
        note13: "九龙区域教育服务处",
        note14: "九龙九龙塘沙福道 19 号教育局九龙塘教育服务中心东座平台",
        note15: "3698 4108",
        note16: "2770 2012",
        note17: "新界西区域教育服务处",
        note18: "新界荃湾青山公路 457 号华懋荃湾广场 19 楼",
        note19: "2437 7272",
        note20: "2416 2750",
        note21: "新界东区域教育服务处",
        note22: "新界上水龙琛路 39 号上水广场 22 楼",
        note23: "2639 4876",
        note24: "2672 0357",
        note25: "地址",
        note26: "电话",
        note27: "传真",
        note28: "香港湾仔皇后大道东 213 号胡忠大厦 14 楼 1424 室",
        note29: "2892 6190",
        note30: "3106 2304",
        note31: "新来港儿童支援分组",
        note32: "2892 6191",
    },
    guidanceNotes: {
        title: "个人资料收集声明",
        // note1: `申请人必须提供有关的个人资料，倘若提供的资料不足，教育局可能无法提供任何协助。`,
        // note2: `此表格所收集的个人资料，将用作协助安排入学时供学校或部门负责人参阅。当有关儿童获安排入学或得到适当协助后，资料如无须保留，将全部销毁。`,
        // note3: `根据《个人资料 ( 私隐 ) 条例》第 18 和 22 条及附表 1 第 6 原则的规定，申请人有权更改或查询个人资料。任何与此表格所收集的个人资料有关的查询，包括要求查阅和改正资料，应提交香港湾仔皇后大道东 213 号胡忠大厦 14 楼 1424 室教育局学位安排及支援组教育主任（学位安排及支援）（电话：2892 6191）。`,
        p_title: "收集个人资料的目的",
        p1_1: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
        p1_a: "处理、核实、审核资格及查证就学位安排的申请；",
        p1_b: "就上文(a)项所述申请的处理、核实、审核资格及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
        p1_c: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；以及",
        p1_d: "编制统计资料、研究及政府刊物。",

        p2: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理有关申请。",

        p_title3: "可获转移资料者",
        p3_1: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        p3_a: "政府其他政策局及部门，以用于上文第1段所述的用途；",
        p3_b: "与本表格相关的学校，以用于上文第1段所述的用途；",
        p3_c: "你曾就披露个人资料给予订明同意；以及",
        p3_d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",

        p_title4: "查阅个人资料",
        p4: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向助理教育主任(学位安排及支援)22提出(地址：香港湾仔皇后大道东213号胡忠大厦14楼1424室或电邮：aeops22@edb.gov.hk)",
    },
};
export default Form076SC;
